export default __webpack_public_path__ + "static/media/yellowspot@4x.5a9b1e2b.png";